// extracted by mini-css-extract-plugin
export default {"settings__wrap":"GameSettings_settings__wrap__UXB3I","label":"GameSettings_label__VAAYV","timer":"GameSettings_timer__O2oO0"};